import { AxiosRequestConfig } from 'axios';
import axiosClient from './request-client';

// Vinculación de la cuenta de Challonge del usuario (OAuth) para capturar su
// id + username. Los endpoints REST viven en la API (/challonge-link/*).

export const getChallongeLinkStatus = (config?: AxiosRequestConfig) =>
  axiosClient.get<{
    linked: boolean;
    challongeId: string | null;
    challongeUsername: string | null;
  }>('/challonge-link/status', config);

export const getChallongeLinkAuthUrl = (
  returnTo: string,
  config?: AxiosRequestConfig
) =>
  axiosClient.get<{ authUrl: string }>('/challonge-link/authorize', {
    ...config,
    params: { ...config?.params, returnTo },
  });

export const unlinkChallonge = (config?: AxiosRequestConfig) =>
  axiosClient.post('/challonge-link/unlink', undefined, config);
